/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class UserLogDialog extends SiteEntityDialog<UserLogRow, any> {
        protected getFormKey() { return UserLogForm.formKey; }
        protected getIdProperty() { return UserLogRow.idProperty; }
        protected getLocalTextPrefix() { return UserLogRow.localTextPrefix; }
        protected getNameProperty() { return UserLogRow.nameProperty; }
        protected getService() { return UserLogService.baseUrl; }

        protected form = new UserLogForm(this.idPrefix);

    }
}